import React from 'react'
import { Link } from 'react-router';

export const JobApplicationsEmpty = () => {
    return (
        <div className="message-no-results">
            <h4 className="h4">No Applications To Display</h4>
            <p className="p-tag">You can check your list of favourites jobs or search for new opportunities:</p>
            <ul className="buttons-left">
                <li>
                    <Link className="btn btn-primary"
                        to={`/my-jobs-section/favourite-jobs`}>
                        <span className="label">Check your favourites roles</span>
                    </Link>
                </li>
                <li>
                    <Link className="btn btn-primary"
                        to={`/jobs`}>
                        <span className="label">Search for roles</span>
                    </Link>
                </li>
            </ul>
        </div>
    )
}



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/JobApplicationsEmpty.js